<script setup>
// §8.2 EmptyState — "an invitation to act, never an apology" (§9).
// Title + one-line reason + primary action. "Nothing needs you today", not
// "No data". An empty state is a GOOD outcome, so it must not read as failure.
</script>

<template>
  <div class="l-empty">
    <div v-if="$slots.icon" class="ic"><slot name="icon" /></div>
    <h4 class="t"><slot name="title" /></h4>
    <p class="r"><slot name="reason" /></p>
    <div v-if="$slots.action" class="a"><slot name="action" /></div>
  </div>
</template>

<style scoped>
.l-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--sp-3);
  padding: var(--sp-8) var(--sp-6);
}
.ic {
  color: var(--icon);
  margin-bottom: var(--sp-1);
  font-size: 26px; /* FA icons scale with font-size */
}
.t {
  font-family: var(--font-display);
  font-size: var(--text-card);
  font-weight: 600;
  color: var(--text);
}
.r {
  font-size: var(--text-base);
  color: var(--text-3);
  max-width: 34ch;
}
.a {
  margin-top: var(--sp-2);
}
</style>
